const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const MessageModal = require("./MessageModal");
const {PORTAL_CONTAINERS} = require("../../../shared/PortalConstants");
const BookstoreUtil = require("../../../shared/BookstoreUtil");
const withVaultDispatch = require("../hoc/withVaultDispatch");
const withVaultUpdate = require("../hoc/withVaultUpdate");
const AT = require("../vault/ActionTypes");
const URLMake = require("../../../shared/URLMake");
const StudentLink = require("./StudentLink");
const GradeChapter = require("../../../shared/GradeChapter");
const Derived = require("../vault/Derived");
const chapterNames = require("../../../shared/data/dbGradeChapterBlock.json")
	.chapterNames;
const _ = require("lodash");
const Quad = require("./Quad");
const Tooltip = require("./Tooltip");
const QuadUtil = require("../util/QuadUtil");
const AssetsUtil = require("../util/AssetsUtil");

const styles = require("./styles/GradeModal.css");
const {atUser} = require("../vault/StateCursors");
const OpsUser = require("../vault/OpsUser");

const getPropsFromVault = (props, vaultState) => {
	const user = atUser(vaultState).get();
	const customScope = OpsUser.getCustomScopeForUser(user) ?? [];
	return {
		customScope,
	};
};

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component, getPropsFromVault);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "GradeModalView",

		propTypes: {
			onClose: PT.func.isRequired,
			backdropStyles: PT.object,
			forChapter: PT.bool,
			forLibrary: PT.bool,
			forTheater: PT.bool,
			user: PT.object.isRequired,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
			customScope: PT.array.isRequired,
		},

		handleClose: function() {
			this.props.onClose();
		},

		getURLIfValid: function(gradeNumber, chapterIndex) {
			if (this.props.forLibrary) {
				if (_.includes(BookstoreUtil.getAvailableGradeNumbers(), gradeNumber)) {
					return URLMake.forLibraryFromNumbers(gradeNumber, chapterIndex);
				}
			} else if (this.props.forTheater) {
				return URLMake.forTheaterFromNumbers(gradeNumber, chapterIndex);
			} else {
				if (GradeChapter.isActiveGrade(gradeNumber, true)) {
					const chapterID = GradeChapter.toChapterID(gradeNumber, chapterIndex);
					if (!GradeChapter.isUnderConstruction(chapterID, true)) {
						return URLMake.forChapterFromNumbers(gradeNumber, chapterIndex);
					}
				}
			}
			return null;
		},

		createComingSoonIcon: function(grade) {
			return (
				<div
					key={"comingSoonGrade" + grade}
					className={styles.gradeModalComingSoonContainer}
				>
					<div className={styles.gradeModalComingSoonTopBandContainer}>
						<img
							className={styles.gradeModalComingSoonTopBand}
							src={
								global.BASE_URL +
								"assets/images/elements/modals/grade" +
								grade +
								"-coming-soon-band.svg"
							}
						/>
						<div className={styles.gradeModalComingSoonText}> Coming Soon</div>
					</div>
				</div>
			);
		},

		avatarToChapter: function(chapterID) {
			const {forChapter} = this.props;
			if (forChapter) {
				// only do this for the chapter page grade modal
				this.props.dispatch({
					type: AT.UPDATE_CHAPTER_PATH_AVATAR,
					context: {
						navAction: "enter-chapter",
						chapterID,
						isUpstairs: false,
					},
				});
			}
		},

		isChapterLockedByCustomScope: function(chapterId) {
			// If there is a custom scope, check if the chapter is in the custom scope and return true
			// otherwise return false because it's not locked by the custom scope (it could
			// be locked by other means, but not this one)
			if (this.props.customScope.length) {
				return !this.props.customScope.includes(chapterId);
			} else {
				return false;
			}
		},

		render: function() {
			const gradeSections = [];

			_.forEach(chapterNames, (chapterList, grade) => {
				// do some HTML-level transforms so chapter lists display nicely
				const displayedChapterList = chapterList.map(chapterTitle => {
					// replace dashes with non-breaking dashes
					chapterTitle = chapterTitle.replace(/\-/g, "\u2011");
					// replace spaces in parentheses groups with non-breaking spaces
					const split = chapterTitle.split("(");
					if (split.length === 2) {
						split[1] = split[1].replace(/\ /g, "\u00A0");
					}
					return split.join("(");
				});
				const currGrade = Number(grade);
				const chapters = [];
				const isActiveGrade = GradeChapter.isActiveGrade(currGrade, true);
				for (let i = 0; i < displayedChapterList.length; i++) {
					let listElement = i + 1 + ". " + displayedChapterList[i];
					let elementClass = styles.invalid;

					if (isActiveGrade) {
						const chapterID = GradeChapter.toChapterID(grade, i);
						if (
							(!GradeChapter.isUnderConstruction(chapterID, true) ||
								(this.props.forLibrary &&
									!_.includes(
										Derived.getInactiveLibraryChapters(),
										chapterID
									))) &&
							(!this.props.forTheater ||
								!_.includes(Derived.getInactiveTheaterChapters(), chapterID))
						) {
							if (this.isChapterLockedByCustomScope(chapterID)) {
								listElement = (
									<Tooltip
										className={styles.disabled}
										tooltipText={"Locked"}
										size="small"
										direction="bottom-right"
									>
										{listElement}
									</Tooltip>
								);
							} else {
								const clickAction = () => {
									this.props.onClose();
									this.avatarToChapter(chapterID);
								};
								listElement = (
									<StudentLink
										className={styles.chapterLink}
										to={this.getURLIfValid(currGrade, i)}
										clickAction={clickAction}
										clickSound={"button-click"}
										useWonkyCursor={true}
									>
										{listElement}
									</StudentLink>
								);
								elementClass =
									styles.valid + " " + styles["grade" + grade + "ItemColor"];
							}
						}
					}
					if (this.props.forTheater && elementClass === styles.invalid) {
						listElement = (
							<Tooltip
								tooltipText={"Coming Soon!"}
								size="medium"
								direction="bottom-right"
							>
								{listElement}
							</Tooltip>
						);
					}
					chapters.push(
						<div key={"grade" + i} className={elementClass}>
							{listElement}
						</div>
					);
				}

				if (isActiveGrade) {
					// pushes list of chapter names to a grade array
					const quadSet = QuadUtil.getChapterModalSet(grade);
					gradeSections.push(
						<div key={"grade" + grade} className={styles["section" + grade]}>
							<div className={styles.header}>
								<Quad
									quad={quadSet.head}
									backgroundClass={styles["header" + grade]}
								/>
								<img
									className={styles.icon}
									src={AssetsUtil.getImageForGrade(grade, "white")}
								/>
							</div>
							<div className={styles.listBody}>
								<Quad
									quad={quadSet.body}
									backgroundClass={styles["background" + grade]}
								/>
								<div className={styles.list}>{chapters}</div>
							</div>
						</div>
					);
				}
			});

			let titleImg;
			if (this.props.forLibrary) {
				titleImg = "book";
			} else if (this.props.forTheater) {
				titleImg = "projector";
			} else {
				titleImg = "bell";
			}
			const bgEl = (
				<img className={styles.bg} src={AssetsUtil.getModal("grade-page")} />
			);

			return (
				<MessageModal
					portalContainer={PORTAL_CONTAINERS.GRADE_MODAL}
					onClose={this.handleClose}
					modalClass={styles.main}
				>
					{bgEl}
					<div className={styles.title}>
						<img
							className={styles.titleImg}
							src={AssetsUtil.getButton(titleImg, "blue")}
						/>
						Chapters
					</div>
					<div className={styles.sections}>{gradeSections}</div>
				</MessageModal>
			);
		},
	})
);
